<template>
  <div :class="classes">
      <pt-page-title title="标签关联表"></pt-page-title>
        <wt-table v-loading="loading" :list="related_list">
            <el-table-column label="标签名称">
                <template slot-scope="scope">
                    <wt-auto-complete :disabled="scope.row.disabled" v-model="scope.row.sourceTagName" :remote="true"
                    :remote-request-data="remoteRequest" autoValue="name" label="name" :is-only-item="true" @change="changeSourceTag(scope.row)" data-vv-as="源标签" name="name" v-validate="'required'"></wt-auto-complete>
                </template>
            </el-table-column>
            <el-table-column label="关联标签">
                <template slot-scope="scope">
                     <wt-auto-complete :disabled="scope.row.disabled" v-model="scope.row.relatedTagName" :remote="true"
                    :remote-request-data="remoteRequest" autoValue="name"  label="name"  @change="changeRelatedTag(scope.row)"  data-vv-as="关联标签" name="name" v-validate="'required'"></wt-auto-complete>
                </template>
            </el-table-column>
            <el-table-column label="权重">
                <template slot-scope="scope">
                    <wt-input-number :disabled="scope.row.disabled" v-model="scope.row.weight" :min="1"  @blur="weightChange(scope.row)" data-vv-as="权重" name="name" v-validate="'required'"></wt-input-number>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="deleteRelatedLabel(scope.row,scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </wt-table>
        <div class="button-div">
            <el-button type="primary" @click="addRelate">添加</el-button>
            <el-button type="primary" plain @click="editRaletedLabel" v-if="!isEdit">编辑</el-button>
            <el-button type="primary" @click="save" :loading="submitLoading" v-if="hasSaveButton">保存</el-button>
        </div>
  </div>
</template>

<script>
// 组件class前缀
import formMixins from 'mixins/form'
const prefixCls = 'pt-related-label'
export default {
  name: 'pt-related-label',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    relatedList: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    resourseLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      related_list: this.relatedList,
      labelQuery: 'getLabelsList',
      paramsData: {
        example: {},
        pageableParam: {
          page: 0,
          size: 500
        }
      },
      resourse_labels: this.resourseLabels,
      hasSaveButton: false,
      isEdit: false
    }
  },
  watch: {
    relatedList: {
      handler: function (val) {
        this.related_list = val
      }
    }
  },
  methods: {
    weightChange (val) {
      let weight = val.weight
      if (weight < 1 || weight > 10) {
        this.$message.error('请输入大于1小于10的标签权重')
        this.$set(val, 'weight', 10)
      }
    },
    changeSourceTag (row) {
      this.resourse_labels.forEach(item => {
        if (item.name === row.sourceTagName) {
          row.sourceTag = item
        }
      })
    },
    changeRelatedTag (row) {
      this.resourse_labels.forEach(item => {
        if (item.name === row.relatedTagName) {
          row.relatedTag = item
          this.$set(row, 'relateedTag', item)
        }
      })
    },
    addRelate () {
      this.hasSaveButton = true
      this.related_list.push({})
    },
    remoteRequest (val, next) {
      this.$emit('remoteRequest', val, next)
    },
    editRaletedLabel () {
      this.isEdit = true
      this.hasSaveButton = true
      this.related_list.forEach(item => {
        item.disabled = false
      })
    },
    formData () {
    },
    save () {
      this.validate('related_list').then(res => {
        this.$emit('submit', this.related_list)
      })
    },
    saveSuccess () {
      this.hasSaveButton = false
      this.isEdit = false
    },
    deleteRelatedLabel (val, index) {
      if (!val.sourceTagName && !val.relatedTagName) {
        this.related_list.splice(index, 1)
      } else {
        this.$confirm('您确定删除该关联标签吗', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(res => {
          if (val.id) {
            this.$emit('deleteRelatedLabel', val)
          } else {
            this.related_list.splice(index, 1)
          }
        })
      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
<style lang="less">
.pt-related-label{
    .button-div{
        .el-button{
            margin-right:30px
        }
    }
}
</style>
